import styles from "./Payment.module.css";
import SuccessAnimation from "./successAnimation";

interface Props {
	onSuccess: () => void;
}
export default function PaymentConfirmation({ onSuccess }: Props) {
	return (
		<div className={styles.paymentConfirmation}>
			<SuccessAnimation />
			<h3 className="text-body">
				THANK YOU FOR
				<br />
				YOUR PURCHASE!
			</h3>
			<button onClick={onSuccess} className={styles.submitBtn}>
				START WATCHING
			</button>

			<p className={styles.infoText}>
				We have received your payment information and are processing your payment. You will receive a confirmation email
				at the address you provided.
			</p>
		</div>
	);
}
